import { getCampaignLiveStatus } from "../types/campaign-live-status.types";

const initState = {
    data: [],
    loading: false,
};

export default function campaignLiveStatusReducer(state = initState, action = {}) {
    switch (action.type) {
        case getCampaignLiveStatus.GET_CAMPAIGN_LIVE_STATUS_REQUEST:
            return {
                ...state,
                loading: true,
                data: []
            };
        case getCampaignLiveStatus.GET_CAMPAIGN_LIVE_STATUS_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload.data
            };
        case getCampaignLiveStatus.GET_CAMPAIGN_LIVE_STATUS_ERROR:
            return {
                ...state,
                loading: false,
            };
        default:
            return state;
    }
}
